import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useListStatusReportStatuses } from '../../../../../api/groups'
import Loading from '../../../../molecules/Loading'
import Text from '../../../../atoms/Text'
import StatusReportStatusEditModal from './StatusReportStatusEditModal'
import StatusIconCard from './StatusIconCard'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    padding: '20px 60px'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px'
  },
  statusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
    gap: '16px'
  },
  statusCard: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: theme.layout.shadow.deep
    }
  }
}))

function StatusManagement () {
  const classes = useStyles()
  const { data: statuses, isLoading } = useListStatusReportStatuses()
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [editorOpen, setEditorOpen] = useState(false)

  const handleEditStatus = (status) => {
    setSelectedStatus(status)
    setEditorOpen(true)
  }

  const handleCloseEditor = () => {
    setEditorOpen(false)
    setSelectedStatus(null)
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div>
          <Text text='Manage Statuses' variant='h1' />
          <Text
            text='Upload custom icons and manage status report statuses'
            variant='body1'
            style={{ marginTop: '8px', color: 'var(--text-color-secondary)' }}
          />
        </div>
      </div>

      <div className={classes.statusGrid}>
        {(statuses || []).map((status) => <StatusIconCard key={status.statusId} status={status} onEdit={handleEditStatus} />)}
      </div>

      {selectedStatus && (
        <StatusReportStatusEditModal
          open={editorOpen}
          status={selectedStatus}
          onClose={handleCloseEditor}
        />
      )}
    </div>
  )
}

export default StatusManagement
